import React from 'react';
import Loadable from 'react-loadable';
import Loader from '../../utils/Loader';

import AuthenticatedLayout from '../../components/Layouts/Authenticated';

const LetterOfCreditReview = Loadable({
    loader: () => import('./letter-of-credit/review'),
    loading() {
        return <Loader />;
    },
});

/** Rendered inside the app chrome so the sidebar and top bar stay in place. */
const ApproveLetterOfCredit = (props: any) => (
    <AuthenticatedLayout>
        <LetterOfCreditReview {...props} />
    </AuthenticatedLayout>
);

export { ApproveLetterOfCredit };
